var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_tab3_third"
  }, [_c('div', {
    staticClass: "box_contain"
  }, [_c('h1', [_vm._v($t("dnhnle4", "权限管理"))]), _c('p', [_vm._v(` ${$t("8e4gry1j", "应用完全启用还需要钉钉开启接口权限对应用维度做授权，鼓励应用使用尽可能多的接口，实现跟钉钉核心能力的全面互通。")} `)])])]);
}];
export { render, staticRenderFns };